import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Image, useDisclosure } from '@chakra-ui/react';
import { Sandbox } from '@finch-api/common/dist/internal/connect/authorize';
import { useQueryClient } from '@tanstack/react-query';

import openLinkSvg from '../../assets/images/icons/open_link.svg';
import { TokenExchangeModal } from './TokenExchangeModal';
import { useApplication } from '../../applications/hooks';
import { COLORS } from '../../constant';

type Props = {
  mode?: Sandbox;
};

const DEFAULT_SCOPES = [
  'company',
  'directory',
  'individual',
  'employment',
  'payment',
  'pay-statement',
];

const FINCH_SANDBOX_SCOPES = ['ssn'];

export const ConnectSandbox = ({ mode }: Props) => {
  const { applicationId } = useParams<{ applicationId: string }>();
  const [code, setCode] = useState<string | null>(null);
  const { isOpen, onClose: onCompleted } = useDisclosure();
  const { isLoading } = useApplication(applicationId);
  const client = useQueryClient();

  return (
    <>
      <Button
        size="sm"
        color={COLORS.FINCH.BLACK}
        isLoading={isLoading}
        fontWeight="normal"
        border={`1px solid ${COLORS.GRAY.GRAY_400}`}
        background={COLORS.WHITE}
        _hover={{ background: COLORS.GRAY.GRAY_200 }}
        rightIcon={<Image src={openLinkSvg} />}
        onClick={() => {
          setCode(null);
        }}
        p="8px 10px"
        minW="fit-content"
      >
        Connect Test Account
      </Button>
      <TokenExchangeModal
        isOpen={isOpen}
        onClose={() => {
          onCompleted();
          client.invalidateQueries({
            queryKey: ['connections'],
          });
        }}
        applicationId={applicationId}
        code={code}
      />
    </>
  );
};
